export const migrate_theme = {
  error_unknown: 'Có lỗi trong hệ thống',
  migrate_error: 'Migrate lỗi',
  migrate_success: 'Migrate thành công',
  migrating: 'Đang Migrate',
} as const;
